import React, { Component } from "react";
import PropTypes from "prop-types";
import { Loader } from "cxa-components";
import { connect } from "react-redux";
import ActivityList from "./activityList";
import {
  loadSignedUpActivities,
  resetReload,
  MY_ACTIVITIES_RESEND_SUCCESS,
} from "actions/shopActivitiesActions";
import { intlShape } from "react-intl";
import messages from "components/messagesDescription";
import { showToast } from "actions/toastActions";

class ActivitiesSignups extends Component {
  componentDidMount() {
    this.reloadData();
  }

  reloadData() {
    const { loadSignedUpActivities, resetReload } = this.props;
    resetReload();
    loadSignedUpActivities();
  }

  componentWillReceiveProps(nextProps) {
    const { resendStatus } = nextProps;
    const { intl, showToast, resendStatus: prevResend } = this.props;

    if (prevResend !== resendStatus && resendStatus === MY_ACTIVITIES_RESEND_SUCCESS) {
      showToast({
        message: intl.formatMessage(messages.voucherResendNotification),
      });
    }
  }

  componentDidUpdate() {
    const { shouldReload } = this.props;

    if (shouldReload) {
      this.reloadData();
    }
  }

  render() {
    const { data, completedSignups, fetching, intl } = this.props;

    if (fetching || !data) {
      return <Loader />;
    }

    const activities = data.filter(
      ({ userSignUps }) =>
        completedSignups
          ? userSignUps[0].statusGroup !== "Outstanding"
          : userSignUps[0].statusGroup === "Outstanding"
    );

    if (activities.length === 0) {
      return <p>{intl.formatMessage(messages.activities.notSignedUp)}</p>;
    }

    const filteredActivities = activities.map(activity => activity.userSignUps[0]);

    return (
      <div>
        <ActivityList
          activities={filteredActivities}
          showCount={false}
          showStatus={true}
          showProvider={false}
          showDownload={true}
          showVoucherActions={true}
        />
      </div>
    );
  }
}

ActivitiesSignups.propTypes = {
  loadSignedUpActivities: PropTypes.func,
  data: PropTypes.array,
  completedSignups: PropTypes.bool,
  resetReload: PropTypes.bool,
  shouldReload: PropTypes.bool,
  fetching: PropTypes.bool,
  intl: intlShape.isRequired,
  showToast: PropTypes.func,
  resendStatus: PropTypes.string,
};

const mapStateToProps = ({
  signedUpActivities: { error, data, fetching },
  shopActivity: { shouldReload, resendStatus },
}) => ({
  error,
  data,
  fetching,
  shouldReload,
  resendStatus,
});

const mapDispatchToProps = {
  loadSignedUpActivities,
  resetReload,
  showToast,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivitiesSignups);



// WEBPACK FOOTER //
// ./components/wellness/activities/activitiesSignups.jsx